fragment AccountLastContactedTimeFragment on Account {
    id
    lastContactedTime
    myLastContactedTime
}
